export const EventAccessRestriction = {
	AUTH:           'auth',
	PAYMENT:        'payment',
	GEOBLOCKED:     'geoblocked',
	PARALLEL_VIEWS: 'parallel_views',
	PASSWORD:       'password',
};
